import PageUserDetails from './PageUserDetails';



export default PageUserDetails;
